import React, { useEffect, useState, useRef } from 'react';
import { supabase } from '../../supabaseClient';
import { useNavigate } from 'react-router-dom';

const AdminNavbar = ({ toggleSidebar }) => {
  const [user, setUser] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const getUser = async () => {
      const { data: { user } } = await supabase.auth.getUser();
      setUser(user);
    };
    getUser();

    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/admin/login');
  };

  return (
    <nav className="bg-white h-16 px-4 sm:px-8 flex items-center justify-between shadow-sm sticky top-0 z-20">
      <div className="flex items-center gap-2">
        {/* Hamburger Menu - Visible on mobile/tablet */}
        <button 
          onClick={toggleSidebar} 
          className="p-2 rounded-md hover:bg-gray-100 lg:hidden text-gray-600 focus:outline-none"
          aria-label="Toggle sidebar"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Logo - Visible on mobile/tablet since sidebar is hidden */}
        <div className="lg:hidden flex items-center">
             <img src="/assets/images/logo/kssb.png" alt="Semesta Logo" className="h-8 w-auto" onError={(e) => {e.target.onerror = null; e.target.src="/assets/images/logo/semesta-logo-full.png"}} />
        </div>
      </div>
      
      {/* Right Side - User Profile & Dropdown */}
      <div className="relative" ref={dropdownRef}>
        <button 
            onClick={() => setDropdownOpen(!dropdownOpen)}
            className="flex items-center gap-4 focus:outline-none hover:bg-gray-50 p-2 rounded-lg transition-colors"
        >
            <div className="text-right hidden sm:block">
              <p className="text-sm font-semibold text-gray-700">Admin</p>
              <p className="text-xs text-gray-500">{user?.email}</p>
            </div>
            <div className="h-10 w-10 rounded-full bg-[#28357B] text-white flex items-center justify-center font-bold text-lg">
              {user?.email ? user.email[0].toUpperCase() : 'A'}
            </div>
             <svg className={`w-4 h-4 text-gray-500 transition-transform ${dropdownOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
             </svg>
        </button>

        {/* Dropdown Menu */}
        {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 ring-1 ring-black ring-opacity-5 z-50">
                <div className="px-4 py-2 text-xs text-gray-500 border-b border-gray-100 sm:hidden">
                    {user?.email}
                </div>
                <button
                    onClick={handleLogout}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                >
                    Sign out
                </button>
            </div>
        )}
      </div>
    </nav>
  );
};

export default AdminNavbar;
